import { InjectionKey, Ref } from "vue";
import { Bot, CreateNodeBody, Node } from "@/@types/ivr";

export const BotDetailsKey: InjectionKey<Ref<Bot | undefined>> = Symbol("botDetails");
export const BotNodesKey: InjectionKey<Ref<Node[]>> = Symbol("botNodes");

export const FetchBotDetailsKey: InjectionKey<() => Promise<void>> = Symbol("fetchBot");
export const FetchNodesKey: InjectionKey<() => Promise<void>> = Symbol("fetchNodes");

export const CurrentOpenedNodeKey: InjectionKey<Ref<number | undefined>> =
  Symbol("currentOpenedNode");

export const DrawerFormStateKey: InjectionKey<Partial<CreateNodeBody>> = Symbol("drawerFormState");
